import '../list/gb-list.tag.html';
import { DidYouMean } from './gb-did-you-mean';
riot.tag2('gb-did-you-mean', '<yield> <gb-list class="{_style}" items="{didYouMean}" scope="gb-did-you-mean" inline> <a onclick="{_scope.send}">{item}</a> </gb-list> </yield>', '', '', function(opts) {
    this._mixin(DidYouMean);
});



/** WEBPACK FOOTER **
 ** ./src/tags/did-you-mean/gb-did-you-mean.tag.html
 **/